/* eslint-disable @typescript-eslint/naming-convention */
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DTypeStatus } from '@grupo-constant/next-dtype/types';
import { catchError, map, Observable } from 'rxjs';
import { BusUser } from './mission-users.types';
import { NextMethodsEnum } from '../../../core/enums/next-methods.enum';
import { HttpService } from '../../../core/http/http.service';
import { DTypeService } from '../../../core/dtype/dtype.service';
import { CompanyUser, CompanyUserCredentialsModel } from '../../../core/user/companyUser.model';

@Injectable({
    providedIn: 'root'
})
/**
 * TODO documentation
 */
export class MissionUsersService {

    static fullUri = 'https://xml.cloudcodice.com/feature/company/Company/1.1.0';
    static resources = {
        create: 'flushCompanyUser',
        read: 'retrieveCompanyUserList',
        update: 'flushCompanyUser',  // no update users resource exists on the server at the time of writing this
        delete: 'deleteCompanyUser',
        search: 'searchCompanyUserList',
        retrieveDatatype: NextMethodsEnum.retrieveDatatype,
    };

    constructor(
        private httpService: HttpService,
        private dTypeService: DTypeService,
    ) { }

    makeCall(resource: string, body: any, errorHandler) {
        const defaultErrorHandler = (err, caught) => {
            console.error(err, caught);
        };
        errorHandler = errorHandler ? errorHandler : defaultErrorHandler;
        return this.httpService.post(resource, body).pipe(catchError(errorHandler));
    }

    retrieveDatatype(datatypeId: string, errorHandler?: (err: HttpErrorResponse) => Observable<any>): Observable<any> {
        const body = { uri: MissionUsersService.fullUri };
        const response = this.makeCall(MissionUsersService.resources.retrieveDatatype, body, errorHandler);
        //TODO set usersForm
        console.warn('Structure users service retrieve datatype not yet implemented');
        return response;
    }

    create(
        body: {
            companyUser: CompanyUser;
            companyUserCredentials?: CompanyUserCredentialsModel;
        },
        errorHandler?: (err: HttpErrorResponse) => Observable<any>
    ): Observable<any> {
        const response = this.makeCall(MissionUsersService.resources.create, body, errorHandler);
        return response;  //TODO extract users
    }

    read(
        body: {
            companyId: string;
            chunkSize: number;
            nextId?: string;
            activeOnly?: boolean;
        },
        errorHandler?: (err: HttpErrorResponse) => Observable<any>
    ): Observable<CompanyUser[]> {
        const requestBody = {
            companyId: body.companyId,
            chunkSize: body.chunkSize,
            nextUserId: body.nextId,
            activeOnly: body.activeOnly,
        };
        return this.makeCall(MissionUsersService.resources.read, requestBody, errorHandler)
            .pipe(map(response => response.companyUser as CompanyUser[]));
    }

    update(
        body: {
            companyUser: CompanyUser;
            companyUserCredentials?: CompanyUserCredentialsModel;
        },
        errorHandler?: (err: HttpErrorResponse) => Observable<any>
    ): Observable<any> {
        //TODO should not create user
        return this.create(body, errorHandler);
        //TODO extract users
    }

    delete(
        body: {
            users: CompanyUser[];
        },
        errorHandler?: (err: HttpErrorResponse) => Observable<any>
    ): Observable<boolean> {
        const requestBody = { userId: body.users.map(user => user.userId) };
        return this.makeCall(MissionUsersService.resources.delete, requestBody, errorHandler);
        //TODO do something with the result
    }

    search(
        body: {
            expression?: string;
            companyIds?: string[];
            activeOnly?: boolean;
        },
        errorHandler?: (err: HttpErrorResponse) => Observable<any>
    ): Observable<CompanyUser[]> {

        const requestBody = {
            expr: body.expression,
            company: body.companyIds,
            activeOnly: body.activeOnly,
        };
        return this.makeCall(MissionUsersService.resources.search, requestBody, errorHandler)
            .pipe(map(response => response.companyUser as CompanyUser[]));
    }

    retrieveDTypeForm(user: CompanyUser, options?: {isUpdate: boolean}) {
        return this.dTypeService.getDtypeFormByUri({
            status: DTypeStatus.LIVE,
            uri: user.uri,
            bindableOptions: true
        }, user.payload, options);
    }

    unlinkMissionUser(user: CompanyUser) { //finishTheParty no es correcto, modificar cuando exista el servicio
        return this.httpService.post(NextMethodsEnum.finishTheParty, { userIdOrHrid: user.userId });
    }

    searchBus(expr: string): Observable<BusUser[]> {
        return this.httpService.post(NextMethodsEnum.searchBusTrabajador, {
            expr
        }).pipe(
            map((response) => {
                if (response && response.busTrabajador) {
                    return response.busTrabajador;
                }
                return [];
            })
        );
    }

    joinTheParty(companyId: string, hrid: string) {
        return this.httpService.post(NextMethodsEnum.joinTheParty, { companyId: companyId, hrid: hrid });
    }

    retrieveUserDailyLog(userId: string, date: string) {
        return this.httpService.post(NextMethodsEnum.retrieveUserDailyLog, { userId: userId, date: date }).pipe(
            map(response => response)
        );
    }

    retrieveUserDailyLogData(dailyLogKey: string, date: string, type: string) {
        return this.httpService.post(NextMethodsEnum.retrieveUserDailyLogData, { dailyLogKey: dailyLogKey, date: date, type: type }).pipe(
            map(response => response.data)
        );
    }

}
